/**
 * Cornell AAP and Cornell Tech marks, floating on the map.
 *
 * The 2023 site pinned these top-left, raw on the map with no backing --
 * workable there because nothing else occupied that corner. This app's
 * masthead already owns top-left, and both marks are solid black on
 * transparent, so stacking them on the dark masthead panel would erase them.
 * Bottom-left is otherwise empty but for Mapbox's own required wordmark, and
 * the basemap there is the same light ground the marks were designed against
 * -- so this keeps the original's "sitting directly on the map" look rather
 * than boxing them into another panel.
 */
export function BrandMark() {
  return (
    <div className="brandmark" aria-hidden="true">
      <img src="/asset/AAP-College-External-black.png" alt="Cornell AAP" />
      <img src="/asset/cornelltech_invert.png" alt="Cornell Tech" />
    </div>
  );
}
